<template>
  <div class="paintings">
    <navigation></navigation>
    <!-- Circle Preloader -->
    <h3>Tattoo</h3>
    <p class="text-center">tattoo artwork with machine and stick and poke</p>
    <div class="container">
      <div class="card-columns">
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo1.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Pi</i><br />
              Machine
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo2.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>LJ, Backpain</i><br />
              Machine
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo3.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>LJ</i><br />
              Machine
            </p>
          </div>
        </div>
        <!-- end row 1 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo4.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti</i><br />
              Selftattooed, Machine
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo12.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Mandarine</i><br />
              Machine, Stick and Poke
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo5.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti</i><br />
              Machine
            </p>
          </div>
        </div>
        <!-- end row 2 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo6.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Zero Day Exploit</i><br />
              Machine
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo7.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Valid CC</i><br />
              Selftattooed, Machine
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo02.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Kiki</i><br />
              Machine, by M.M.S.
            </p>
          </div>
        </div>
        <!-- end row 3 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo9.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Funnel of Love</i><br />
              Machine
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo10.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Cross</i><br />
              Stick and Poke
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo11.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>H</i><br />
              Stick and Poke
            </p>
          </div>
        </div>
        <!-- end row 4 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo13.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Boca</i><br />
              Selftattooed, Machine
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo14.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Testskin</i><br />
              Machine
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo15.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bierdeckel</i><br />
              Stick and Poke
            </p>
          </div>
        </div>
        <!-- end row 5 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo16.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>La Madrina</i><br />
              Selftattooed, Machine
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo17.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Valid CC</i><br />
              Selftattoed, Machine
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo19.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Ernst Frich Camera</i><br />
              Machine
            </p>
          </div>
        </div>
        <!-- end row 6 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo01.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Female Zampano</i><br />
              Selftattooed, Machine
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/tattoo/tattoo00.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Undine</i><br />
              Stick and Poke
            </p>
          </div>
        </div>

        <!-- end row 7 -->
      </div>
      <!-- -->
    </div>

    <!--container end div-->
    <back-to-top bottom="20px" right="20px">
      <button type="button" class="btn btn-light btn-to-top">
        <i class="fa fa-chevron-up"></i>
      </button>
    </back-to-top>
  </div>
</template>

<script>
import navigation from "@/components/navigation.vue";

export default {
  components: {
    navigation,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss">
@import "./../sass/_main.scss";
</style>
